<template>
  <div>
    <form @submit.prevent="checkForm">
      <div>
        <v-text-field
          v-model="nombreArea"
          label="Nombre de la Puerta de Acceso"
          :error-messages="errores.name ? [errores.name] : []"
          outlined
          dense
          required
        ></v-text-field>
      </div>

      <div class="text-right">
        <v-btn color="green" dark @click="checkForm">Guardar</v-btn>
        <v-btn @click="$emit('toggle', false)" color="red" dark>
          Cancelar
        </v-btn>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "PuertasAccesoForm",
  props: ["dataEdit"],
  data() {
    return {
      nombreArea: "",
      id: null,
      errores: {},
    };
  },
  methods: {
    checkForm() {
      let valido = true;
      this.errores = {};

      if (!this.nombreArea) {
        this.errores.name = "El nombre de la puerta de acceso es obligatorio";
        valido = false;
      } else {
        this.errores.name = false;
      }

      if (valido) {
        this.$emit("successData", {
          nm: this.nombreArea,
          id: this.id ? this.id : "",
          edit: !!this.dataEdit,
        });
      }
    },
  },
  mounted() {
    if (this.dataEdit) {
      this.nombreArea = this.dataEdit.nm;
      this.id = this.dataEdit.id;
    }
  },
};
</script>
